export { default as Img200 } from './processed/200/Last-Week-Tonight.jpg';
export { default as Img400 } from './processed/400/Last-Week-Tonight.jpg';
export { default as Imgthumb } from './processed/thumb/Last-Week-Tonight.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Last-Week-Tonight.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Last-Week-Tonight.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "LightVibrant": {
    "_rgb": [
      236,
      204,
      196
    ],
    "_population": 4,
    "_hsl": [
      0.03333333333333333,
      0.512820512820513,
      0.8470588235294119
    ]
  },
  "Muted": {
    "_rgb": [
      141,
      78,
      75
    ],
    "_population": 422,
    "_hsl": [
      0.007575757575757584,
      0.3055555555555555,
      0.42352941176470593
    ]
  },
  "LightMuted": {
    "_rgb": [
      180,
      200,
      212
    ],
    "_population": 3068,
    "_hsl": [
      0.5625000000000001,
      0.2711864406779662,
      0.7686274509803922
    ]
  },
  "DarkMuted": {
    "_rgb": [
      42,
      42,
      45
    ],
    "_population": 2099,
    "_hsl": [
      0.6666666666666666,
      0.034482758620689696,
      0.17058823529411765
    ]
  },
  "Vibrant": {
    "_rgb": [
      0,
      0,
      0
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Last-Week-Tonight.js